import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../redux';
import { createSimplePracticeInvitation, createSimplePracticeInvitationBulk } from '../../redux/invitation/invitationSlice';

export const useInviteSimplePracticeClinician = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const inviteOne = useCallback(async (payload: { clinicianId: string; email: string; firstName: string; lastName: string }) => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      await dispatch(createSimplePracticeInvitation(payload)).unwrap();
      setSuccess('Invite sent successfully');
      return true;
    } catch (e: any) {
      setError(e?.message || 'Failed to send invite');
      return false;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  const inviteBulk = useCallback(async (payload: { clinicianIds: string[] }) => {
    setLoading(true);
    setError(null); 
    setSuccess(null);
    try {
      await dispatch(createSimplePracticeInvitationBulk(payload)).unwrap();
      setSuccess('Bulk invites sent successfully');
      return true;
    } catch (e: any) {
      setError(e?.message || 'Failed to send bulk invites');
      return false;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  return { inviteOne, inviteBulk, loading, error, success };
};  